import React from "react";
import "./style.css";
import Selected from "../../Assets/Icons/Selected";

export const ImageContainer = ({ image, name, selected , price}) => {

  
  return (
    <div className={`container-border ${selected ? "selected" : ""} buy-package-img-card`}>
      <div className="image-container">
        {selected && (
          <div className="svg-overlay">
            <Selected />
          </div>
        )}

        <img src={image} alt={name} />
        <div className="overlay">
          <p className="overlay-text">{name}</p>
          <p className="overlay-text price">Price: <span>${price}</span></p>
        </div>
      </div>
    </div>
  );
};
